module.exports = __webpack_public_path__ + "ab3e500e7375695d702cff19513e4470.woff2";